import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const socialLinks = [
    { icon: 'ri-weibo-line', href: 'http://zwrn.cn/', label: '微博' },
    { icon: 'ri-bilibili-line', href: 'http://zwrn.cn/', label: 'B站' },
    { icon: 'ri-wechat-line', href: '#', label: '微信' },
    { icon: 'ri-live-line', href: '#', label: '抖音' },
  ];

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-6 md:px-10 lg:px-16 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          <div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold mb-5">
              {t('site.name')}
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs mb-6">
              {t('footer.brand.desc')}
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-300 hover:text-accent-400 hover:border-accent-400 transition-all duration-300 cursor-pointer"
                  aria-label={link.label}
                >
                  <i className={`${link.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-2">
                {t('footer.address')}
              </h4>
              <p className="text-sm text-foreground-300">{t('footer.address.value')}</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-2">
                {t('footer.phone')}
              </h4>
              <p className="text-sm text-foreground-300">{t('footer.phone.value')}</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-2">
                {t('footer.email')}
              </h4>
              <a href="mailto:hello@zwrn.cn" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-300">
                {t('footer.email.value')}
              </a>
            </div>
          </div>

          <div>
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20of%20warm%20amber%20and%20emerald%20tones%20blending%20together%2C%20modern%20editorial%20design%2C%20sophisticated%20gradient%20textures%2C%20elegant%20flowing%20shapes%2C%20high-end%20magazine%20aesthetic%2C%20soft%20atmospheric%20lighting%2C%20artistic%20abstraction%20with%20subtle%20depth%20and%20dimension&width=320&height=420&seq=footer-team-photo&orientation=portrait"
              alt="51吃瓜网团队"
              className="w-full max-w-[200px] h-auto rounded-lg object-cover"
              title="51吃瓜网团队"
            />
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-foreground-400 hover:text-accent-400 transition-colors duration-300 whitespace-nowrap">
              {t('footer.link1')}
            </Link>
            <Link to="/about" className="text-xs text-foreground-400 hover:text-accent-400 transition-colors duration-300 whitespace-nowrap">
              {t('footer.link2')}
            </Link>
            <Link to="/about" className="text-xs text-foreground-400 hover:text-accent-400 transition-colors duration-300 whitespace-nowrap">
              {t('footer.link3')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}